import { html } from "lit";
import { customElement, query } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import SlDialog from "@shoelace-style/shoelace/dist/components/dialog/dialog";

import "./ContributorStats";

@customElement("ds-contributor-stats-dialog")
export class ContributorStatsDialog extends BaseElement {
    @query("#dialog") protected _dialog: SlDialog | undefined;

    override render() {
        return html`<sl-dialog
            id="dialog"
            open
            label="Top contributors"
            @ds-accept=${() => this._dialog?.hide()}
        >
            <ds-contributor-stats></ds-contributor-stats>
        </sl-dialog>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-contributor-stats-dialog": ContributorStatsDialog;
    }
}
